import Index from '../../views/main/functionalIcons/Index'
import Edit from '../../views/main/functionalIcons/Edit'
import Create from '../../views/main/functionalIcons/Create'

export default [
  {
    component: Index,
    name: 'functional-icons-index',
    path: '/functional-icons',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
    }
  },
  {
    component: Edit,
    name: 'functional-icons-edit',
    path: '/functional-icons/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
    }
  },
  {
    component: Create,
    name: 'functional-icons-create',
    path: '/functional-icons/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
    }
  }
]
